import styled from 'styled-components';

import { Loader, LoaderSize } from '@dreryk/react-components';

export const StyledPageLoader = styled.div`
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
`;
StyledPageLoader.displayName = 'StyledPageLoader';

export const PageLoader = (): JSX.Element => (
   <StyledPageLoader>
      <Loader size={LoaderSize.BIG} testId={'pageLoader'} />
   </StyledPageLoader>
);
